import { render, staticRenderFns } from "./DocumentHeader.vue?vue&type=template&id=2649e399&"
import script from "./DocumentHeader.vue?vue&type=script&lang=js&"
export * from "./DocumentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports